import { requestJSON } from "./api";

export interface GlobalUser {
  user_id: string; email: string; display_name: string; lifecycle: string;
  created_at: string; updated_at: string; last_login_at?: string; locked_until?: string;
  auth_revision: number; local_password_state: "configured" | "disabled" | "unknown";
  providers: string[]; active_sessions: number;
  teams: Array<{ team_id: string; display_name: string; data_center_id: string; status: string }>;
}
export interface GlobalUserPage {
  items: GlobalUser[]; total: number; limit: number; offset: number;
  mfa_available: boolean; session_revocation_scope: string;
}
export interface IdentityProvider {
  provider: "google" | "github" | "wecom"; enabled: boolean; client_id: string; agent_id: string;
  secret_configured: boolean; revision: number; source: "database" | "deployment";
  updated_by: string; updated_at: string; callback_url: string;
}
export interface IdentityProviderPage {
  items: IdentityProvider[]; writable: boolean; unavailable_reason?: string; directory_sync_available: boolean;
}
export interface IdentityProviderInput {
  expected_revision: number; enabled: boolean; client_id: string; agent_id: string; client_secret?: string;
}
export function listGlobalUsers(search: string, offset: number, signal?: AbortSignal): Promise<GlobalUserPage> {
  const query = new URLSearchParams({q: search, offset: String(offset), limit: "25"});
  return requestJSON(`/api/v1/identity/users?${query}`, {signal});
}
export function resetGlobalUserPassword(csrfToken: string, user: GlobalUser, password: string, reason: string) {
  return requestJSON<{user_id: string; auth_revision: number; revoked_sessions: number; session_revocation_scope: string}>(`/api/v1/identity/users/${encodeURIComponent(user.user_id)}/password`, {
    method: "POST", csrfToken, reason, body: {expected_revision: user.auth_revision, password}
  });
}
export function listIdentityProviders(signal?: AbortSignal): Promise<IdentityProviderPage> {
  return requestJSON("/api/v1/identity/providers", {signal});
}
export function updateIdentityProvider(csrfToken: string, provider: string, input: IdentityProviderInput, reason: string): Promise<IdentityProvider> {
  return requestJSON(`/api/v1/identity/providers/${encodeURIComponent(provider)}`, {method: "PUT", csrfToken, reason, body: input});
}
